export const riderImportTemplate = `firstName,lastName,dob,phoneNumber,email,gender,height,weight
John,Doe,1990-05-12,1234567890,john.doe@email.com,MALE,5'11",180
Jane,Smith,1985-10-20,9876543210,jane.smith@email,FEMALE,5'5",140
Alex,Taylor,2000-07-15,5551234567,alex.taylor@email.com,OTHER,5'8",160
Sam,Lee,1995-03-22,4449876543,sam.leeemail.com,DECLINE_TO_SAY,6'0",175
Dean,Ambrose,1989-01-25,4449876543,,ABC,,`;
